@if (preview) {
  <ul class="uploaded-items text-center">
    <li [class.inline-avatar]="_isInlineAvatar">
      @if (_value || _file) {
        <span
          (click)="_remove()"
          role="button"
          tabindex="0"
          aria-label="Close"
          aria-hidden="false"
        >
          <i class="myre-icon-close" aria-hidden="true"></i>
        </span>
        @if (withAvatar) {
          <avatar
            [size]="avatarSize"
            [withBorder]="true"
            [imageSrc]="_getUrl()"
          />
        } @else {
          <img [src]="_getUrl()" alt="..." />
        }
      }
    </li>
  </ul>
}

@if (design === 'area') {
  <div
    class="upload-area myre-add-area"
    [attr.myre-progress]="_progress / 100 | percent"
    [class.uploading]="_uploading"
    [class.loading]="loading"
  >
    <span class="upload-area-input">
      <input
        #fileinput
        type="file"
        [multiple]="false"
        [accept]="accept"
        [disabled]="loading || readonly || disabled"
        (change)="_onFileSelect($event)"
      />
    </span>

    <i class="myre-icon-add"></i>
    <i (click)="_cancel()" class="myre-icon-close" aria-label="Cancel"></i>

    <p>{{ '_library.filepicker.oneFile' | translate }}</p>

    <div class="progress" [style.right.%]="100 - _progress"></div>

    @if (loading) {
      <div class="extraction-loader">
        <div class="extraction-loader__bar"></div>
      </div>
    }
  </div>
}

@if (design === 'button') {
  <div
    class="upload-area"
    [class.no-preview]="!_value"
    [class.inline-avatar]="_isInlineAvatar"
  >
    <input
      #fileinput
      type="file"
      [multiple]="false"
      [accept]="accept"
      (change)="_onFileSelect($event)"
    />

    <myre-action-button
      [label]="label"
      [disabled]="readonly"
      [adaptText]="adaptText"
      [withDesktopIcon]="!!iconName"
      [reverse]="reverse"
      [color]="color"
      [type]="type"
      [iconName]="iconName"
      (onClick)="fileinput.click()"
    />
  </div>
}
